// extracted by mini-css-extract-plugin
export default {"centreAlign":"Footer_centreAlign__70fWw"};